// extracted by mini-css-extract-plugin
module.exports = {"contHeaderInf":"styles_contHeaderInf__2WuRy"};